import { BirdviewHomeContactType } from '../DashboardBirdview.constants'

export const BIRDVIEW_HOME_PHONE_SEPARATOR_PATTERN = /\s/g

export const BIRDVIEW_HOME_CONTACT_TOOLTIP_KEY = {
  [BirdviewHomeContactType.Email]:
    'DashboardBirdview.ClickToWriteEmailTooltipKey',
  [BirdviewHomeContactType.Phone]: 'DashboardBirdview.ClickToCallTooltipKey',
}
